import { ICSSInJSStyle, pxToRem } from "@fluentui/react-northstar";
import { useLayoutEffect, useState } from "react";

import { useFluentColorScheme } from "../../../../shared/theme/useColorScheme";
import { useDeviceTesterStateContext } from "../../../device-tester-context-provider/DeviceTesterContextProvider";
interface SidePanelButton {
  sidePanelButton: ICSSInJSStyle;
}

export const useSidePanelButtonStyles: () => SidePanelButton = () => {
  const { brand, main } = useFluentColorScheme();
  const { deviceTesterState } = useDeviceTesterStateContext();

  const [infoFetched, setInfoFetched] = useState(
    deviceTesterState.isInfoFetched
  );

  useLayoutEffect(() => {
    setInfoFetched(deviceTesterState.isInfoFetched);
  }, [deviceTesterState.isInfoFetched]);

  return {
    sidePanelButton: {
      backgroundColor: "transparent",
      color: infoFetched ? brand.foreground2 : main.foregroundDisabled,
      border: `1px solid ${
        infoFetched ? brand.border2 : main.foregroundDisabled
      }`,
      borderRadius: "5px",
      padding: `${pxToRem(0)} ${pxToRem(8)}`,
      height: "32px",
    },
  };
};
